import React, { useState, useEffect } from "react";
import Modal from "../components/Modal";
import {
  getCollections,
  createCollection,
  updateCollection,
  deleteCollection,
} from "../../firebase/firestoreService";

const emptyForm = () => ({ name: "", description: "" });

export default function CollectionsSection() {
  const [collections, setCollections] = useState([]);
  const [loading,     setLoading]     = useState(true);
  const [modalOpen,   setModalOpen]   = useState(false);
  const [editing,     setEditing]     = useState(null);
  const [form,        setForm]        = useState(emptyForm());
  const [saving,      setSaving]      = useState(false);

  useEffect(() => { fetchAll(); }, []);

  const fetchAll = async () => {
    setLoading(true);
    setCollections(await getCollections());
    setLoading(false);
  };

  const openAdd  = () => { setEditing(null); setForm(emptyForm()); setModalOpen(true); };
  const openEdit = (c) => { setEditing(c); setForm({ name: c.name, description: c.description || "" }); setModalOpen(true); };
  const closeModal = () => { setModalOpen(false); setEditing(null); };
  const setField = (k, v) => setForm((f) => ({ ...f, [k]: v }));

  const handleSave = async () => {
    if (!form.name.trim()) { alert("Collection name is required."); return; }
    setSaving(true);
    if (editing) {
      await updateCollection(editing.id, form);
    } else {
      await createCollection(form);
    }
    await fetchAll();
    setSaving(false);
    closeModal();
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete this collection?")) return;
    await deleteCollection(id);
    setCollections((prev) => prev.filter((c) => c.id !== id));
  };

  return (
    <div>
      <div className="dash-main__header">
        <h2 className="dash-main__title">Collections</h2>
        <button className="btn-primary" onClick={openAdd}>+ Add Collection</button>
      </div>

      {loading ? (
        <p className="dash-empty">Loading…</p>
      ) : collections.length === 0 ? (
        <p className="dash-empty">No collections yet.</p>
      ) : (
        <div className="dash-table-wrap">
          <table className="dash-table">
            <thead>
              <tr>
                <th>Name</th>
                <th>Description</th>
                <th>Actions</th>
              </tr>
            </thead>
            <tbody>
              {collections.map((c) => (
                <tr key={c.id}>
                  <td><strong>{c.name}</strong></td>
                  <td style={{ color: "#777" }}>{c.description || "—"}</td>
                  <td>
                    <button className="btn-edit" onClick={() => openEdit(c)}>Edit</button>
                    <button className="btn-danger" onClick={() => handleDelete(c.id)}>Delete</button>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {modalOpen && (
        <Modal title={editing ? "Edit Collection" : "Add Collection"} onClose={closeModal}>
          <div className="form-group">
            <label className="form-label">Collection Name *</label>
            <input
              className="form-input"
              value={form.name}
              onChange={(e) => setField("name", e.target.value)}
              placeholder="e.g. Soleil Collection"
            />
          </div>
          <div className="form-group">
            <label className="form-label">Description</label>
            <textarea
              className="form-textarea"
              value={form.description}
              onChange={(e) => setField("description", e.target.value)}
              placeholder="Short description of this collection…"
            />
          </div>
          <div className="form-actions">
            <button className="btn-cancel" onClick={closeModal}>Cancel</button>
            <button className="btn-primary" onClick={handleSave} disabled={saving}>
              {saving ? "Saving…" : editing ? "Save Changes" : "Add Collection"}
            </button>
          </div>
        </Modal>
      )}
    </div>
  );
}
